<table class="-collapsible hide md:table">
    <thead class="-no-heading-bg">
        <tr>
            @if (!tableData().fixTitleRow) {
                <th
                    class="align:l"
                    [innerHTML]="tableData().subtitles[0]"
                ></th>
            }
            @for (subtitle of subtitles(); track subtitle; let i = $index) {
                <th
                    class="align:c"
                    [ngClass]="{ '-active': i === active() }"
                    (click)="activate(i)"
                    [innerHTML]="subtitle"
                ></th>
            }
        </tr>
    </thead>
    <tbody>
        @for (row of tableData().rows; track row) {
            <tr>
                @if (!tableData().fixTitleRow) {
                    <td [innerHTML]="row.title"></td>
                }
                @for (cell of row.cells; track cell; let i = $index) {
                    <td class="align:c">
                        @if (cell.type === 'text') {
                            <span
                                class="text-cell"
                                [innerHTML]="cell.value"
                            ></span>
                        }
                        @if (cell.type === 'check') {
                            <span>
                                <span
                                    class="check-cell {{ cell.iconColor }}"
                                    [ngClass]="{ '-okay': cell.checkmark, '-nope': !cell.checkmark }"
                                    [attr.aria-label]="cell.value ? '' : cell.checkmark ? 'Ja' : 'Nein'"
                                ></span>
                                @if (cell.value) {
                                    <small [innerHTML]="cell.value"></small>
                                }
                            </span>
                        }
                    </td>
                }
            </tr>
        }
        <ng-content></ng-content>
    </tbody>
</table>

<div
    role="tablist"
    class="md:hide"
>
    @if (tableData().collapsedTitle || tableData().title) {
        <div
            class="heading"
            [ngClass]="{
                'md:hide': !tableData().title,
            }"
            [attr.colspan]="tableWidth()"
        >
            <span>{{ tableData().collapsedTitle || tableData().title }}</span>
        </div>
    }
    <div class="button-wrapper">
        @for (subtitle of subtitles(); track subtitle; let i = $index) {
            <button
                type="button"
                role="tab"
                [attr.aria-selected]="i === active()"
                [attr.aria-controls]="'tabpanel-' + i"
                [id]="'tab-' + i"
                (click)="activate(i)"
                (keydown)="handleKeydown($event)"
                [tabindex]="i === active() ? 0 : -1"
            >
                <span [innerHTML]="subtitle"></span>
            </button>
        }
    </div>
    @for (columnCell of tableData().rows[0].cells; track $index; let column = $index) {
        <div
            [id]="'tabpanel-' + column"
            role="tabpanel"
            [attr.aria-labelledby]="'tab-' + column"
            class="hide"
            [ngClass]="{ block: column === active() }"
        >
            <ul>
                @for (row of tableData().rows; track $index) {
                    @let cell = row.cells[column];
                    <li class="align:c">
                        @if (row.title) {
                            <span
                                class="row-title"
                                [innerHTML]="row.title"
                            ></span>
                        }
                        @if (cell.type === 'text') {
                            <span
                                class="text-cell"
                                [innerHTML]="cell.value"
                            ></span>
                        }
                        @if (cell.type === 'check') {
                            <span>
                                <span
                                    class="check-cell {{ cell.iconColor }}"
                                    [ngClass]="{ '-okay': cell.checkmark, '-nope': !cell.checkmark }"
                                    [attr.aria-label]="cell.value ? '' : cell.checkmark ? 'Ja' : 'Nein'"
                                ></span>
                                @if (cell.value) {
                                    <small [innerHTML]="cell.value"></small>
                                }
                            </span>
                        }
                    </li>
                }
            </ul>
        </div>
    }
</div>

@for (note of tableData().footnotes; track note) {
    <small>
        {{ note }}
        <br />
    </small>
}
